import { create } from 'zustand';

import type { Admin } from '../types/admin.types';

// Minimal coordinator: an edit panel rendered at page level needs to know which
// admin is being edited, while the row-level [수정] button is the trigger. The
// store carries the full Admin object (list query already supplies it, no need
// for a second fetch).
interface AdminEditState {
  editing: Admin | null;
  open: (admin: Admin) => void;
  close: () => void;
}

export const useAdminEditStore = create<AdminEditState>((set) => ({
  editing: null,
  open: (admin) => set({ editing: admin }),
  close: () => set({ editing: null }),
}));
